/* eslint-disable max-len */
export default {
	filterTitle: 'Kontakty',
	availableContacts: 'Počet kontaktů',
	assignedContacts: 'Přidělené kontakty',
	client: 'Klient',
	birthNumber: 'Rodné číslo/IČO',
	address: 'Adresa',
	assignedTo: 'Přiděleno na',
	status: 'Stav',
	phone: 'Telefon',
	policyNo: 'Číslo PS',
	policyAgent: 'Správce PS',
	all: 'Všechny',
	toBeReleased: 'K uvolnění',
	toBeAssigned: 'K přidělení',
	contactState: 'Stav kontaktu',
	policyEndDate: 'Datum konce smlouvy',
	assignLevel: 'Úroveň přidělení',
	printType: 'Tisk',
	businessName: 'Název',
	surname: 'Příjmení klienta',
	firstName: 'Jméno klienta',
	municipality: 'Obec',
	zipCode: 'PSČ',
	personIn: 'Rodné číslo',
	businessIn: 'IČO',
	// Added columns
	print: 'Tisk dopisu',
	insurancePremium: 'Výše pojistného',
	product: 'Produkt',
	policyFinishDate: 'Datum konce smlouvy',
	isSeller: 'Získatel',
	// Sidebar
	assignReleaseContacts: 'Přidělení / uvolnění kontaktů',
	contactRelease: 'Uvolnění kontaktů',
	printingType: 'Způsob tisku',
	noPrint: 'Bez tisku',
	anonymousPrint: 'Anonymní tisk',
	namedPrint: 'Jmenný tisk',
	printNotAllowed: 'Vypršel čas pro nastavení tisku kampaně nebo není tisk povolen.',
	automaticAssign: 'Automatické přidělení',
	assignByZipCode: 'Na oblast dle PSČ',
	assignBySolver: 'Dle správce smlouvy a PSČ',
	manualAssign: 'Manuální přidělení',
	execute: 'Provést',
	executeAll: 'Provést na všech',
	cancel: 'Zrušit',
	// dialogs
	noSellerSelected: 'Uvolněné kontakty lze přidělit, je-li vyplněna organizační struktura až po obchodníka.',
	noSelectContact: 'Zvolte alespoň jeden záznam v tabulce kontaktů',
	noContactsAvailable: 'Nebyly vyhledány žádné záznamy ke zpracování',
	noProcessSelected: 'Nejdříve je nutné zvolit akci, kterou chcete provést v sekci Přidělení/uvolnění kontaktů.',
	contactProcessingError: 'Některé záznamy nebylo možné zpracovat.',
	// progress
	progressMessage:
		'Probíhá {{progressType}}, vyčkejte prosím na aktualizaci stránky. Zůstává zpracovat {{contactNumber}} kontaktů.',
	releaseProgressType: 'uvolnění kontaktů',
	assignProgressType: 'přidělení kontaktů',
	printProgressType: 'nastavení tisků',
	// lightbox
	lightboxTitle: 'Opravdu si přejete provést operaci na všech vyhledaných záznamech?',
};
